// Darstellung des Urhebers einer Veranstaltung (US-105, PRD-020)
//
// Eigene Datei, weil die Regeln testbar sein müssen: die ~13.000 importierten
// Bestandsobjekte tragen `six-cms` statt einer Adresse, und ein Datensatz ohne
// `createdByRole` darf keine Rolle vortäuschen.

/** Wert, den der Server für importierte Bestandsobjekte liefert. */
export const IMPORTED_AUTHOR = 'six-cms';

/**
 * Kürzt eine Adresse auf den Teil vor dem `@`.
 *
 * Die Domäne ist bei allen Konten dieselbe (`@jacques.de`) und kostet in einer
 * Tabellenspalte nur Platz. Die vollständige Adresse steht im `title`-Attribut, also
 * beim Überfahren mit der Maus — sie geht nicht verloren.
 *
 * `six-cms` bleibt unverändert stehen: es ist der reguläre Wert für die Bestandsobjekte
 * und soll wie eine Angabe aussehen, nicht wie ein Fehler. Ein leerer Wert ergibt einen
 * Gedankenstrich statt einer leeren Zelle, damit „nichts hinterlegt" von „Spalte
 * versehentlich leer" unterscheidbar bleibt.
 */
export function formatAuthor(createdBy: string | undefined): string {
  const value = createdBy?.trim();
  if (!value) return '—';
  if (value === IMPORTED_AUTHOR) return value;

  const local = value.split('@')[0];
  return local && local.length > 0 ? local : value;
}
